const uomByMaterialVendorMock = [
  {
    vendor: "42.756.008/0001-05",
    materialNfe: "100803412B",
    uoms: [
      { value: "UN", label: "UN - Unidade" },
      { value: "CX", label: "CX - Caixa" },
      { value: "CT", label: "CT - Cento" },
    ],
  },
  {
    vendor: "42.756.008/0001-05",
    materialNfe: "1008750",
    uoms: [
      { value: "TB", label: "TB - Tubo" },
      { value: "UN", label: "UN - Unidade" },
    ],
  },
  {
    vendor: "42.756.008/0001-05",
    materialNfe: "22054",
    uoms: [
      { value: "PC", label: "PC - Peça" },
      { value: "CT", label: "CT - Cento" },
    ],
  },
];

export function getUomOptionsByMaterialVendor(materialNfe, vendor) {
  const found = uomByMaterialVendorMock.find(
    (item) =>
      String(item.materialNfe) === String(materialNfe) &&
      String(item.vendor) === String(vendor),
  );

  return found?.uoms ?? [];
}

export default uomByMaterialVendorMock;